import React, { Component } from "react";
import ReactDOM from "react-dom";
import Creatable from "react-select/creatable";
import {
  Button,
  Modal,
  ModalFooter,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  FormGroup,
  Container,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import awsLogo from "../../assets/images/aws_logo.png";
import azureLogo from "../../assets/images/azure_logo.svg";
import { connect } from "react-redux";
import {
  registerOrgAccount,
  registerOrgAccountSuccessful,
  getListOfOrgsAndAccts,
  getAwsAcc,
  clearAllOrgAccountMessages,
} from "../../store/actions";
import {
  getReleaseDetailsRequest,
  clearAllReleaseMessages,
} from "../../store/actions";

import { getRegionCode } from "../../utilities/countries";
import { Tooltip } from "@material-ui/core";
import { Snackbar, Link, Box, Typography, Divider, List, ListItem, ListItemText } from "@mui/material";
import { Alert } from "@material-ui/lab";

import {
  verifyAccountStatusRequest,
  clearAllScanServiceMessages,
} from "../../store/scanService/scanServiceSlice";

import { isPossiblePhoneNumber } from "react-phone-number-input";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { validateAddressWithAPI } from '../../helpers/addressValidation';
import {
  postAzureOnboardingTemplate,
  postAzureOnboardingFetchDetails,
  postAzureOnboardingVerify,
} from '../../helpers/auth_aws_helper';

class OrgAccount extends Component {
  constructor(props) {
    super(props);
    this.abortController = null;
    const initialAccountType =
      props.initialAccountType === "AWS" || props.initialAccountType === "AZURE"
        ? props.initialAccountType
        : "";
    this.state = {
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Register an AWS account", link: "#" },
      ],
      activeTab: 1,
      orgId: "",
      orgName: "",
      orgCode: "",
      accountNumber: "",
      accountName: "",
      accountCode: "",
      urlLink: "",
      location: "",
      accountType: initialAccountType,
      address: "",
      country: "",
      email: "",
      emailDomain: "",
      phonenumber: "",
      phonenumberError: null,
      eula: "blah",
      currentStepError: false,
      accountResourceGroups: ["Default"],
      selectedOption: { value: "Default", label: "Default" },
      defaultOptions: [
        { value: "H.R.", label: "H.R." },
        { value: "Finance", label: "Finance" },
        { value: "Engineering", label: "Engineering" },
        { value: "Unassigned", label: "Unassigned" },
      ],
      roleName: "CloudCatcherTrustRole",
      externalId: "",
      copy: false,
      copiedField: null,
      awsAccNumber: "placeholder",
      showCopyLinkHelp: false,

      //added for MUI Stepper support
      step: 1, // Step 1: Select Cloud Account Type
      modal_addons: false,

      verifyAccount: null, // 1 means verified and 0 means not verified
      verifyAccountError: false, // true means error in verification
      verifyAccountSuccess: false, //true means verified and false means not

      registerAccountError: false, // Error for display error while creating account

      addressValidationStatus: null,
      addressValidationMessage: '',
      city: '',
      state: '',
      zip: '',

      azureTemplateLoading: false,
      azureTemplateError: null,
      azureDownloadUrl: "",
      azureDeployToAzureUrl: "",
      azureOnboardingId: "",
      azureExpiresInSeconds: null,
      azureTemplateReady: false,

      customerTenantId: "",
      registrationDefinitionId: "",
      registrationAssignmentId: "",
      azureVerifyLoading: false,
      azureVerifyError: null,

      azureStep3Visible: false,
      azureFetchDetailsLoading: false,
      azureFetchDetailsError: null,
      azureHideViewButton: false,
      azureStatusMessage: null,
      azureStatusSeverity: null, // 'success' | 'error'
      copiedField: null,

      // Mount point in parent ModalBody (above Nav tabs)
      wizardChromeHost: null,
    };
    this.linkTextAreaRef = React.createRef();
  }

  resetState = () => {
    this.setState({
      orgId: "",
      orgName: "",
      orgCode: "",
      accountNumber: "",
      accountName: "",
      accountCode: "",
      urlLink: "",
      location: "",
      accountType: "",
      address: "",
      country: "",
      email: "",
      emailDomain: "",
      phonenumber: "",
      phonenumberError: null,
      currentStepError: false,
      accountResourceGroups: ["Default"],
      selectedOption: { value: "Default", label: "Default" },
      showCopyLinkHelp: false,
      step: 1,
      modal_addons: false,

      verifyAccount: null,
      verifyAccountError: false,
      verifyAccountSuccess: false,

      registerAccountError: false,

      addressValidationStatus: null,
      addressValidationMessage: '',
      city: '',
      state: '',
      zip: '',

      azureTemplateLoading: false,
      azureTemplateError: null,
      azureDownloadUrl: "",
      azureDeployToAzureUrl: "",
      azureOnboardingId: "",
      azureExpiresInSeconds: null,
      azureTemplateReady: false,

      customerTenantId: "",
      registrationDefinitionId: "",
      registrationAssignmentId: "",
      azureVerifyLoading: false,
      azureVerifyError: null,

      azureStep3Visible: false,
      azureFetchDetailsLoading: false,
      azureFetchDetailsError: null,
      azureHideViewButton: false,
      azureStatusMessage: null,
      azureStatusSeverity: null,
      copiedField: null,
    });
    if (this.props.onAzureFetchDetailsComplete) {
      this.props.onAzureFetchDetailsComplete(false);
    }
  };

  closeAcctSuccesmsg = () => {
    this.props.newAccountAdded();
    this.resetState();
    this.props.handleAddAccountsModal();
  };

  handleManualPairingGuide = async (e) => {
    e.stopPropagation();
    this.props.getReleaseDetails(
      encodeURIComponent(
        "configurations/Step-by-Step Guide to Pair New Account.pdf"
      )
    );
  };

  handleResourceExplorerGuide = async (e) => {
    e.stopPropagation();
    this.props.getReleaseDetails(process.env.REACT_APP_RESOURCE_EXPLORER_MANUAL_GUIDE);
  };

  handleClickExternalId = () => {
    navigator.clipboard.writeText(this.state.externalId);
    this.setState({ copy: true });
    setTimeout(() => this.setState({ copy: false }), 3000);
  };

  handleClickSubscriptionId = () => {
    this.handleCopyAzureField("subscriptionId", this.state.accountNumber);
  };

  handleCopyAzureField = (fieldKey, value) => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    this.setState({ copiedField: fieldKey });
    setTimeout(() => {
      this.setState((prev) =>
        prev.copiedField === fieldKey ? { copiedField: null } : null
      );
    }, 3000);
  };

  componentDidMount() {
    console.log("--=== componentDidMount in orgAccount", this.props);
    if (this.props.organizations === null || this.props.accounts === null) {
      console.log(
        "--=== componentDidMount, calling this.props.getListOfOrgsAndAccts()"
      );
      this.props.getListOfOrgsAndAccts();
    }
    if (this.props.aws === null) {
      console.log("--=== componentDidMount, calling this.props.getAwsAcc()");
      this.props.getAwsAcc();
    }
    
    // Only set externalId if organizations data is available
    if (this.state.externalId === null || this.state.externalId === "") {
      if (this.props.organizations && this.props.organizations.length > 0 && this.props.organizations[0] && this.props.organizations[0].externalid) {
        this.setState({ externalId: this.props.organizations[0].externalid });
      }
    }

    // Notify parent of initial step
    if (this.props.onStepChange) {
      this.props.onStepChange(this.state.step);
    }

    this.abortController = new AbortController();

    this.setState({
      wizardChromeHost: document.getElementById("add-account-wizard-chrome"),
    });
  }

  componentWillUnmount() {
    console.log("--=== componentWillUnmount ");
    this.resetState();
    console.log("clearing all scanService messages...");
    this.props.clearAllScanServiceMessages();

    if (this.abortController) {
      this.abortController.abort();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (typeof this.props.account === "string") {
      this.toggleTab(this.state.activeTab);
    }

    // Notify parent of step changes
    if (prevState.step !== this.state.step && this.props.onStepChange) {
      this.props.onStepChange(this.state.step);
    }

    if (
      this.props.reg_acct_error &&
      this.props.reg_acct_error !== prevProps.reg_acct_error
    ) {
      this.setState({ registerAccountError: true });
      setTimeout(() => this.setState({ registerAccountError: false }), 5000);
    }
    
    // Reset verification if externalId changes
    const currentExternalId = this.props?.organizations?.[0]?.externalid;
    const prevExternalId = prevProps?.organizations?.[0]?.externalid;
    if (currentExternalId && currentExternalId !== prevExternalId && currentExternalId !== this.state.externalId) {
      // Clear scan service messages to reset error state from props
      this.props.clearAllScanServiceMessages();
      this.setState({
        externalId: currentExternalId,
        verifyAccountSuccess: false,
        verifyAccountError: false,
      });
    }
    
    if (
      this.props?.organizations[0]?.orgbillingemail &&
      this.state.emailDomain === ""
    ) {
      this.setState({
        emailDomain:
          "@" + this.props.organizations[0].orgbillingemail.split("@").pop(),
      });
    }

    if (this.props.releaseDetails) {
      if (this.props.releaseDetails !== null) {
        const newTab = window.open(this.props.releaseDetails, "_blank");
        newTab.focus();
        this.props.clearAllReleaseMessages();
      }
    }

    if (this.props?.accountStatusResult) {
      if (!this.state.verifyAccountSuccess) {
        this.setState({
          verifyAccountSuccess: true,
          verifyAccountError: false,
        });
      }
    } else if (this.props?.accountStatusError) {
      if (!this.state.verifyAccountError) {
        this.setState({
          verifyAccountSuccess: false,
          verifyAccountError: true,
        });
      }
    }
  }

  verifyPairedAccountStatus = async () => {
    if (this.state.accountType === "AZURE") {
      await this.verifyAzureOnboarding();
      return;
    }
    this.props.verifyAccountStatus(
      this.state.accountNumber,
      this.state.roleName,
      this.state.externalId
    );
  };

  isAzureVerifyFormInvalid = () => {
    return (
      !this.isValidAzureGuid(this.state.accountNumber) ||
      !this.isValidAzureGuid(this.state.customerTenantId) ||
      !this.isValidAzureGuid(this.state.registrationDefinitionId) ||
      !this.isValidAzureGuid(this.state.registrationAssignmentId)
    );
  };

  verifyAzureOnboarding = async () => {
    if (this.isAzureVerifyFormInvalid()) {
      this.setState({
        currentStepError: true,
        azureVerifyError:
          "Customer Tenant ID, Registration Definition ID, and Registration Assignment ID must be valid GUIDs (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).",
      });
      return false;
    }

    const customerTenantId = this.normalizeAzureGuid(this.state.customerTenantId);
    const registrationDefinitionId = this.normalizeAzureGuid(
      this.state.registrationDefinitionId
    );
    const registrationAssignmentId = this.normalizeAzureGuid(
      this.state.registrationAssignmentId
    );

    this.setState({
      customerTenantId,
      registrationDefinitionId,
      registrationAssignmentId,
    });

    const resourceGroupName =
      this.state.accountResourceGroups[0] ||
      this.state.selectedOption?.value ||
      "Default";

    const payload = {
      connectionMode: "AZURE_LIGHTHOUSE",
      customerTenantId,
      subscriptionId: this.state.accountNumber,
      accountName: this.state.accountName,
      registrationDefinitionId,
      registrationAssignmentId,
      accountResourceGroups: [
        {
          resourcename: resourceGroupName,
          description: resourceGroupName,
        },
      ],
      subscription: {
        name: "Basic",
        addons: [],
      },
      complianceAddOns: [],
    };

    this.setState({
      azureVerifyLoading: true,
      azureVerifyError: null,
      verifyAccountSuccess: false,
      verifyAccountError: false,
      currentStepError: false,
      azureStatusMessage: null,
      azureStatusSeverity: null,
    });

    try {
      const response = await postAzureOnboardingVerify(payload);
      const body = response?.data;
      const statusValue = String(body?.status || "").toUpperCase();
      // Backend returns CONNECTED on successful verify (also accept SUCCESS)
      const statusOk =
        response?.status === 200 &&
        (!body?.status ||
          statusValue === "SUCCESS" ||
          statusValue === "CONNECTED");

      if (statusOk) {
        this.setState({
          azureVerifyLoading: false,
          verifyAccountSuccess: true,
          verifyAccountError: false,
          azureVerifyError: null,
          azureStatusMessage:
            (typeof body?.message === "string" && body.message) ||
            "Azure Lighthouse connection verified successfully",
          azureStatusSeverity: "success",
        });
        return true;
      }
      this.setState({
        azureVerifyLoading: false,
        verifyAccountSuccess: false,
        verifyAccountError: true,
        azureVerifyError:
          (typeof body?.message === "string" && body.message) ||
          (typeof body?.error === "string" && body.error) ||
          "Azure pairing could not be verified. Please check the provided IDs.",
        azureStatusMessage:
          (typeof body?.message === "string" && body.message) ||
          (typeof body?.error === "string" && body.error) ||
          "Azure pairing could not be verified. Please check the provided IDs.",
        azureStatusSeverity: "error",
      });
      return false;
    } catch (err) {
      this.setState({
        azureVerifyLoading: false,
        verifyAccountSuccess: false,
        verifyAccountError: true,
        azureVerifyError:
          "Azure pairing could not be verified. Please try again.",
        azureStatusMessage:
          "Azure pairing could not be verified. Please try again.",
        azureStatusSeverity: "error",
      });
      return false;
    }
  };

  fetchAzureLighthouseDetails = async () => {
    this.setState({
      azureFetchDetailsLoading: true,
      azureFetchDetailsError: null,
      azureStep3Visible: false,
      customerTenantId: "",
      registrationDefinitionId: "",
      registrationAssignmentId: "",
      verifyAccountSuccess: false,
      verifyAccountError: false,
      azureVerifyError: null,
      azureStatusMessage: null,
      azureStatusSeverity: null,
    });
    if (this.props.onAzureFetchDetailsComplete) {
      this.props.onAzureFetchDetailsComplete(false);
    }

    try {
      const response = await postAzureOnboardingFetchDetails({
        connectionMode: "AZURE_LIGHTHOUSE",
        subscriptionId: this.state.accountNumber,
      });
      const body = response?.data;
      const statusOk =
        response?.status === 200 &&
        String(body?.status || "").toUpperCase() === "SUCCESS";

      if (statusOk) {
        this.setState({
          azureFetchDetailsLoading: false,
          azureFetchDetailsError: null,
          azureStep3Visible: true,
          customerTenantId: body.customerTenantId
            ? this.normalizeAzureGuid(body.customerTenantId)
            : "",
          registrationDefinitionId: body.registrationDefinitionId
            ? this.normalizeAzureGuid(body.registrationDefinitionId)
            : "",
          registrationAssignmentId: body.registrationAssignmentId
            ? this.normalizeAzureGuid(body.registrationAssignmentId)
            : "",
          accountNumber: body.subscriptionId
            ? this.normalizeAzureGuid(body.subscriptionId)
            : this.state.accountNumber,
          azureStatusMessage:
            (typeof body?.message === "string" && body.message) ||
            "Azure Lighthouse connection verified successfully",
          azureStatusSeverity: "success",
        });
        if (this.props.onAzureFetchDetailsComplete) {
          this.props.onAzureFetchDetailsComplete(true);
        }
        return;
      }

      this.setState({
        azureFetchDetailsLoading: false,
        azureStep3Visible: false,
        azureFetchDetailsError:
          (typeof body?.message === "string" && body.message) ||
          (typeof body?.reason === "string" && body.reason) ||
          "Failed to fetch Azure Lighthouse details. Please try again.",
        azureStatusMessage:
          (typeof body?.message === "string" && body.message) ||
          (typeof body?.reason === "string" && body.reason) ||
          "Failed to fetch Azure Lighthouse details. Please try again.",
        azureStatusSeverity: "error",
      });
      if (this.props.onAzureFetchDetailsComplete) {
        this.props.onAzureFetchDetailsComplete(false);
      }
    } catch (err) {
      this.setState({
        azureFetchDetailsLoading: false,
        azureStep3Visible: false,
        azureFetchDetailsError:
          "Failed to fetch Azure Lighthouse details. Please try again.",
        azureStatusMessage:
          "Failed to fetch Azure Lighthouse details. Please try again.",
        azureStatusSeverity: "error",
      });
      if (this.props.onAzureFetchDetailsComplete) {
        this.props.onAzureFetchDetailsComplete(false);
      }
    }
  };

  handleAzureSubmit = async () => {
    const ok = await this.verifyAzureOnboarding();
    if (!ok) return;
    enqueueSnackbar("Azure account paired successfully", {
      variant: "success",
    });
    // Brief delay so the accounts API can return the newly paired subscription
    await new Promise((resolve) => setTimeout(resolve, 300));
    this.props.newAccountAdded();
    this.resetState();
    this.props.handleAddAccountsModal();
  };

  isAccountVerified = () => {
    return this.state.verifyAccountSuccess;
  };

  static getDerivedStateFromProps(props, state) {
    if (props.accounts) {
      const id = props.accounts.map((acct) => {
        return acct.orgId;
      });
      return { orgId: parseInt(id.toString()) };
    }

    return {
      ...state,
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab && this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  };

  handlePhoneChange = (value) => {
    this.setState({ phonenumber: value });
  };

  handlePhoneBlur = () => {
    let isInvalidResult;
    if (!this.state.phonenumber) {
      isInvalidResult = true;
    } else {
      isInvalidResult = !isPossiblePhoneNumber(this.state.phonenumber);
    }
    if (isInvalidResult) {
      this.setState({ phonenumberError: "Please enter a valid phone number" });
    } else {
      this.setState({ phonenumberError: null });
    }
  };

  handleInputChange = (e) => {
    if (e.target.name === "phonenumber") {
    } else {
      // Reset verification status if account-related fields change
      const fieldsThatRequireReVerification = [
        "accountNumber",
        "accountName",
        "roleName",
        "customerTenantId",
        "registrationDefinitionId",
        "registrationAssignmentId",
      ];
      const { name, value } = e.target;
      
      if (fieldsThatRequireReVerification.includes(name)) {
        // Clear scan service messages to reset error state from props
        this.props.clearAllScanServiceMessages();
        this.setState({
          [name]: value,
          verifyAccountSuccess: false,
          verifyAccountError: false,
          azureVerifyError: null,
        });
      } else {
        this.setState({
          [name]: value,
        }, () => {
          if (name === "accountType" && this.props.onAccountTypeChange) {
            this.props.onAccountTypeChange(value);
          }
        });
      }
    }
  };

  handleSelectChange = (selectedOption) => {
    if (selectedOption === null) {
      this.setState({
        selectedOption: { value: "Default", label: "Default" },
        accountResourceGroups: ["Default"],
      });
    } else {
      this.setState({
        selectedOption,
        accountResourceGroups: [selectedOption.value],
      });
    }
  };

  handleCheckboxChange = () => {
    this.setState({
      termsAndConditionsAgreement: !this.state.termsAndConditionsAgreement,
    });
  };

  handleSubmit = () => {
    let resourceGroups = this.state.accountResourceGroups.length
      ? this.state.accountResourceGroups.map((str) => ({ resourcename: str }))
      : [{ resourcename: "Default" }];

    let accountRequest = {
      orgId: this.state.orgId,
      accountNumber: this.state.accountNumber,
      accountName: this.state.accountName,
      accountCode: this.state.accountCode,
      urlLink: this.state.urlLink,
      accountType: this.state.accountType,
      address: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      email: '',
      phonenumber: '',
      eula: this.state.eula,
      accountResourceGroups: resourceGroups,
      iamrole: this.state.roleName,
      externalId: this.state.externalId,
    };
    
    this.props.registerOrgAccount(accountRequest);
    console.log("accountRequest = ", accountRequest);
  };

  handleAccountStep = () => {
    const {
      accountNumber,
      accountName,
      accountType,
      roleName,
    } = this.state;
    if (
      accountNumber !== "" &&
      accountName !== "" &&
      accountType !== "" &&
      roleName !== ""
    ) {
      this.setState({ currentStepError: false });
      return true;
    } else {
      this.setState({ currentStepError: true });
      return false;
    }
  };

  redirect = () => {
    this.props.history.push("/dashboard");
  };

  pertformCopyBtnUiChanges = (textAreaEl) => {
    document.getElementById("clickToCopyBtnId").textContent = "Copied";
    setTimeout(() => {
      document.getElementById("clickToCopyBtnId").textContent = "Click to Copy";
      textAreaEl.focus();
      textAreaEl.selectionStart = textAreaEl.selectionEnd = 0;
    }, 3000);
  };

  handleClicktoCopy = () => {
    if (this.linkTextAreaRef && this.linkTextAreaRef.current) {
      const tag = this.linkTextAreaRef.current;
      tag.select();
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(tag.value);
        this.pertformCopyBtnUiChanges(tag);
      } else {
        document.execCommand("copy");
        this.pertformCopyBtnUiChanges(tag);
      }
    }
  };

  fetchAzureOnboardingTemplate = async () => {
    this.setState({
      azureTemplateLoading: true,
      azureTemplateError: null,
      azureTemplateReady: false,
    });
    try {
      const response = await postAzureOnboardingTemplate({});
      const payload = response?.data;
      if (
        response?.status === 200 &&
        payload?.status === "SUCCESS" &&
        payload?.downloadUrl
      ) {
        this.setState({
          azureDownloadUrl: payload.downloadUrl,
          azureDeployToAzureUrl: payload.deployToAzureUrl || "",
          azureOnboardingId: payload.onboardingId || "",
          azureExpiresInSeconds: payload.expiresInSeconds ?? null,
        });

        let jsonText = "";
        try {
          const fileRes = await fetch(payload.downloadUrl);
          if (!fileRes.ok) {
            throw new Error("Failed to fetch template file");
          }
          const text = await fileRes.text();
          try {
            jsonText = JSON.stringify(JSON.parse(text), null, 2);
          } catch {
            jsonText = text;
          }
        } catch {
          this.setState({
            azureTemplateLoading: false,
            azureTemplateReady: false,
            azureTemplateError:
              "Template was generated but the Lighthouse JSON could not be loaded. Please try View again.",
          });
          if (this.props.onAzureLighthouseJsonChange) {
            this.props.onAzureLighthouseJsonChange(null);
          }
          return;
        }

        this.setState({
          azureTemplateLoading: false,
          azureTemplateError: null,
          azureTemplateReady: true,
        });
        if (this.props.onSidePanelOpen) {
          this.props.onSidePanelOpen();
        }
        if (this.props.onAzureLighthouseJsonChange) {
          this.props.onAzureLighthouseJsonChange(jsonText);
        }
        return;
      }
      this.setState({
        azureTemplateLoading: false,
        azureTemplateReady: false,
        azureTemplateError:
          payload?.message ||
          "Failed to generate Azure onboarding template. Please try again.",
      });
      if (this.props.onAzureLighthouseJsonChange) {
        this.props.onAzureLighthouseJsonChange(null);
      }
    } catch (err) {
      this.setState({
        azureTemplateLoading: false,
        azureTemplateReady: false,
        azureTemplateError:
          "Failed to generate Azure onboarding template. Please try again.",
      });
      if (this.props.onAzureLighthouseJsonChange) {
        this.props.onAzureLighthouseJsonChange(null);
      }
    }
  };

  handleAzureTemplateView = () => {
    this.fetchAzureOnboardingTemplate();
  };

  handleNext = async () => {
    if (this.state.step === 1) {
      // Merged Step 1: cloud type + account details
      if (this.state.accountType !== "AWS" && this.state.accountType !== "AZURE") {
        return;
      }
      if (this.props.onAccountTypeChange) {
        this.props.onAccountTypeChange(this.state.accountType);
      }
      const proceedFromAccountDetails = () => {
        if (!this.handleAccountStep()) return;
        // Advance to pairing (step 3) with empty fetch fields — Azure View/Fetch handle APIs
        if (this.props.onAzureFetchDetailsComplete) {
          this.props.onAzureFetchDetailsComplete(false);
        }
        this.setState({
          step: 3,
          azureStep3Visible: false,
          azureHideViewButton: false,
          azureFetchDetailsError: null,
          azureFetchDetailsLoading: false,
          azureTemplateReady: false,
          customerTenantId: "",
          registrationDefinitionId: "",
          registrationAssignmentId: "",
          verifyAccountSuccess: false,
          verifyAccountError: false,
          azureVerifyError: null,
          azureStatusMessage: null,
          azureStatusSeverity: null,
        });
      };
      if (this.state.accountType === "AZURE") {
        const normalized = this.normalizeAzureSubscriptionId(this.state.accountNumber);
        if (normalized !== this.state.accountNumber) {
          this.setState({ accountNumber: normalized }, proceedFromAccountDetails);
          return;
        }
      }
      proceedFromAccountDetails();
    } else if (this.state.step === 2) {
      // Legacy step 2 skipped after merge; continue to pairing
      this.setState({ step: 3 });
    } else if (this.state.step === 3) {
      if (this.state.accountType === "AZURE") {
        // Stay on Page 2; fetchdetails + inline Step 3 (no separate Step 3 page)
        await this.fetchAzureLighthouseDetails();
      } else {
        this.setState({ step: 4 });
      }
    } else if (this.state.step === 4) {
      this.setState({ step: 5 });
    } else if (this.state.step === 5) {
      if (this.state.verifyAccountSuccess) {
        this.handleSubmit();
      }
    }
  };
  
  handleBack = () => {
    if (this.state.step <= 1) return;
    // Azure skips AWS Resource Explorer (step 4) when going back from verify
    if (this.state.accountType === "AZURE" && this.state.step === 5) {
      this.setState({ step: 3 });
      return;
    }
    // Skip removed details-only step 2; return to merged Step 1
    if (this.state.step === 3 || this.state.step === 2) {
      if (this.props.onAzureLighthouseJsonChange) {
        this.props.onAzureLighthouseJsonChange(null);
      }
      if (this.props.onAzureFetchDetailsComplete) {
        this.props.onAzureFetchDetailsComplete(false);
      }
      this.setState({
        step: 1,
        azureDownloadUrl: "",
        azureTemplateError: null,
        azureTemplateReady: false,
        azureStep3Visible: false,
        azureHideViewButton: false,
        azureFetchDetailsError: null,
        azureFetchDetailsLoading: false,
        customerTenantId: "",
        registrationDefinitionId: "",
        registrationAssignmentId: "",
        verifyAccountSuccess: false,
        verifyAccountError: false,
        azureVerifyError: null,
        azureStatusMessage: null,
        azureStatusSeverity: null,
      });
      return;
    }
    this.setState({ step: this.state.step - 1 });
  };

  // Azure IDs (Subscription / Tenant / Registration) are GUIDs:
  // accept hyphenated or 32 hex chars, normalize to 8-4-4-4-12
  normalizeAzureGuid = (value) => {
    const compact = (value || "").trim().replace(/-/g, "");
    if (!/^[0-9a-fA-F]{32}$/.test(compact)) {
      return (value || "").trim();
    }
    return `${compact.slice(0, 8)}-${compact.slice(8, 12)}-${compact.slice(12, 16)}-${compact.slice(16, 20)}-${compact.slice(20)}`;
  };

  isValidAzureGuid = (value) => {
    const compact = (value || "").trim().replace(/-/g, "");
    return /^[0-9a-fA-F]{32}$/.test(compact);
  };

  normalizeAzureSubscriptionId = (value) => this.normalizeAzureGuid(value);

  isValidAzureSubscriptionId = (value) => this.isValidAzureGuid(value);

  handleAccountNumberBlur = () => {
    if (this.state.accountType !== "AZURE") return;
    const normalized = this.normalizeAzureGuid(this.state.accountNumber);
    if (normalized !== this.state.accountNumber) {
      this.setState({ accountNumber: normalized });
    }
  };

  handleAzureGuidFieldBlur = (fieldName) => {
    const normalized = this.normalizeAzureGuid(this.state[fieldName]);
    if (normalized !== this.state[fieldName]) {
      this.setState({ [fieldName]: normalized });
    }
  };

  isAccountInvalid = () => {
    const regex = /^[^ @]+$/;
    const isInvalidItems = [
      {
        field: "email",
        isInvalid: false,
      },
      {
        field: "accountNumber",
        isInvalid:
          this.state.accountType === "AWS"
            ? this.state.accountNumber.length !== 12 ||
              !/^[0-9]+$/.test(this.state.accountNumber)
            : !this.isValidAzureSubscriptionId(this.state.accountNumber),
      },
      {
        field: "accountName",
        isInvalid: this.state.accountName.length === 0 ? true : false,
      },
      {
        field: "phonenumber",
        value: '',
        isInvalid: false,
      },
      {
        field: "address",
        isInvalid: false,
      },
      {
        field: "country",
        isInvalid: false,
      },
      {
        field: "roleName",
        isInvalid: this.state.roleName.length === 0 ? true : false,
      },
    ];

    return isInvalidItems.filter((item) => item.isInvalid).length > 0;
  };
  isCurrentStepInvalid = () => {
    if (this.state.step === 1) {
      if (this.state.accountType !== "AWS" && this.state.accountType !== "AZURE") {
        return true;
      }
      return this.isAccountInvalid();
    } else if (this.state.step === 2) {
      return this.isAccountInvalid();
    } else if (this.state.step === 3) {
      return false;
    } else if (this.state.step === 4) {
      return false;
    } else if (this.state.step === 5) {
      return this.state.verifyAccountSuccess !== true;
    }
    return false;
  };

  static getStepInformation = (step, accountType = "AWS") => {
    const isAzure = accountType === "AZURE";
    const cloudLabel = isAzure ? "Azure" : "AWS";

    switch (step) {
      case 1:
        return {
          title: "Select Cloud & Enter Details",
          steps: [
            "Choose AWS or Azure for the account you want to add.",
            `Enter the ${cloudLabel || "cloud"} account details (Account / Subscription ID and Account Name).`,
            "Assign a Resource Group to the account.\n\nResource Group is an access group that connects this cloud account with the users permitted to view its data. If none is selected, the account will be assigned to the Default Resource Group.\n\nNote: A Resource Group can include multiple cloud accounts, but each account can belong to only one Resource Group.",
          ]
        };
      case 2:
        return {
          title: "Select Cloud & Enter Details",
          steps: [
            "Choose AWS or Azure for the account you want to add.",
            `Enter the ${cloudLabel || "cloud"} account details (Account / Subscription ID and Account Name).`,
            "Assign a Resource Group to the account.\n\nResource Group is an access group that connects this cloud account with the users permitted to view its data. If none is selected, the account will be assigned to the Default Resource Group.\n\nNote: A Resource Group can include multiple cloud accounts, but each account can belong to only one Resource Group.",
          ]
        };
      case 3:
        if (isAzure) {
          return {
            title: "Subscription Pairing Instructions",
            steps: [
              "Click View to generate your Lighthouse JSON template in this panel.",
              "  (a). Copy or download the template, then complete the service provider pairing in your Azure portal.",
              "Sign into your Azure portal using an account that has access to the subscription being paired.",
              "In the Azure portal search bar, search and select: Deploy a Custom Template > Select Build your own template in the editor.",
              "Delete the default template. Either:",
              "  i. Paste the CloudCatcher-generated ARM template, or",
              "  ii. Use Load file and select the downloaded JSON template.",
              "  iii. Click Save.",
              "Review Deployment Details. Verify the appropriate Subscription selected, Region (if applicable), and Parameters (if prompted). Select Review + Create to deploy the template. Azure will validate and deploy the Azure Lighthouse registration.",
              "Come back to CloudCatcher",
              "  i. Select Fetch to retrieve the outputs.",
              "  ii. Manual Entry: To manually enter the IDs in CloudCatcher, navigate to the Outputs tab for the Azure deployment. Copy and enter the last 32 characters of the GUID for both the Registration Definition ID and the Registration Assignment ID.",
            ]
          };
        }
        return {
          title: "Account Pairing",
          steps: [
            "Before beginning this step, log in to the AWS Management Console of the AWS Account you are onboarding. Verify that you have the necessary permissions to create an IAM role.",
            "On CloudCatcher, click on \"Click to Launch\" or copy the link and paste it into your search bar. You will be redirected to your AWS console.",
            "Under Select trusted entity:",
            "  i. Select \"AWS Account\"",
            "  ii. Ensure \"Another AWS account\" is selected.",
            "  iii. Select \"Require external ID (Best practice when a third party will assume this role)\"",
            "  iv. Click Next",
            "In the Add permissions section, use the search function to find the \"ReadOnlyAccess\" policy.",
            "  i. Utilize the \"Filter by Type\" dropdown menu to choose \"AWS managed - job function\". Ensure that the \"ReadOnlyAccess\" policy is selected.",
            "  ii. Click Next",
            "Ensure that the role name is set to \"CloudCatcherTrustRole\". If there is a particular naming convention for roles within your organization, please name the role accordingly. Note down the role name, as it will be required in the \"Verify Pairing\" phase of the AWS Account Onboarding Process. In the \"Description (Optional)\" field, enter a description.",
            "Confirm that the \"ReadOnlyAccess\" policy is selected. For Tags (Optional), add relevant tag information by following your company's Tagging guidelines.",
            "  i. Click Create Role",
            "Note: Ensure that the role is not accidentally deleted by automated IAM roles cleanup tools or exercise."
          ]
        };
      case 4:
        // Azure skips this AWS-only Resource Explorer step
        if (isAzure) {
          return { title: "", steps: [] };
        }
        return {
          title: "Enable AWS Resource Explorer",
          steps: [
            "Before beginning this step, ensure you are logged in to the AWS Management Console of the AWS Account you are onboarding. Verify that you have the necessary permissions to enable Resource Explorer",
            "Click \"Enable AWS Resource Explorer\" in CloudCatcher. You will be redirected to the AWS Resource Explorer page on your console.",
            "  i. Select turn on Resource Explorer to the left",
            "  ii. Choose Quick setup",
            "  iii. Select the AWS Region that will contain the aggregator index",
            "  iv. Select \"Turn on Resource Explorer\" button at the bottom of the page",
            "  v. Monitor the progress on the Progress page",
            "Once the status is successful, come back to CloudCatcher and select \"Submit\"."
          ]
        };
      case 5:
        return {
          title: "Verify Account Pairing",
          steps: isAzure
            ? [
                "Confirm the Subscription ID from Step 1",
                "Enter the Customer Tenant ID",
                "Enter the Registration Definition ID",
                "Enter the Registration Assignment ID",
                "Click Verify Pairing",
                "Click Submit",
              ]
            : [
                "Enter the Trust Role name you created in the Account Pairing step",
                "Click Verify Pairing",
                "Click Submit",
              ],
        };
      default:
        return { title: "", steps: [] };
    }
  };

  validateAddress = async () => {
    const { address, country } = this.state;
    if (!address.trim() || country === "Select Country") return;

    this.setState({ 
      addressValidationStatus: null,
      addressValidationMessage: 'Validating address...'
    });

    const regionCode = getRegionCode(country);
    if (!regionCode) {
      this.setState({
        addressValidationStatus: 'invalid',
        addressValidationMessage: 'Please select a valid country first'
      });
      return;
    }

    try {
      const result = await validateAddressWithAPI(
        address, 
        regionCode, 
        process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      );

      this.setState({
        addressValidationStatus: result.isValid ? 'valid' : 'invalid',
        addressValidationMessage: result.message,
        city: result.city,
        state: result.state,
        zip: result.zip,
        address: result.formattedAddress || address
      });
    } catch (error) {
      this.setState({
        addressValidationStatus: 'invalid',
        addressValidationMessage: 'Failed to validate address. Please try again.'
      });
    }
  };

  renderWizardChrome = () => {
    if (this.props.wizardChromeActive === false) {
      return null;
    }
    const host = this.state.wizardChromeHost;
    if (!host) {
      return null;
    }

    let content = null;

    if (this.state.step === 1) {
      content = (
        <div>
          <div>
            <p>
              <strong style={{ fontSize: "1.2em" }}>Step 1 :</strong>{" "}
              <span style={{ fontSize: "1em" }}>
                Select Cloud & Enter Details
              </span>
            </p>
            <hr />
          </div>
          <p>What type of cloud account do you want to add?</p>
          <div className="cloud-account-type-options">
            <label className="cloud-account-type-option">
              <input
                className="radio-img"
                type="radio"
                name="accountType"
                value="AWS"
                onChange={this.handleInputChange}
                checked={this.state.accountType === "AWS"}
              />
              <div className="cloud-account-type-card">
                <img src={awsLogo} alt="AWS account type" />
              </div>
            </label>
            <label className="cloud-account-type-option">
              <input
                className="radio-img"
                type="radio"
                name="accountType"
                value="AZURE"
                onChange={this.handleInputChange}
                checked={this.state.accountType === "AZURE"}
              />
              <div className="cloud-account-type-card">
                <img src={azureLogo} alt="Azure account type" />
              </div>
            </label>
          </div>
        </div>
      );
    } else if (this.state.step === 3) {
      content = (
        <div>
          <div>
            <p style={{ marginBottom: 8 }}>
              <strong style={{ fontSize: "1.2em" }}>Step 2 :</strong>{" "}
              <span style={{ fontSize: "1em" }}>
                {this.state.accountType === "AZURE"
                  ? "Subscription Pairing"
                  : "Account Pairing"}
              </span>
            </p>
            <hr style={{ marginTop: 0, marginBottom: 10 }} />
          </div>
          {this.state.accountType === "AZURE" ? (
            <p style={{ marginBottom: 0 }}>
              Click View to generate your Azure Lighthouse JSON template. Follow
              the steps on the right panel. After you complete the process in
              your Azure portal, click Fetch to retrieve your subscription
              registration details. Click Submit to finish pairing your
              subscription.
            </p>
          ) : (
            <p>
              Pair your AWS account with CloudCatcher. Follow the{" "}
              <Link
                component="button"
                onClick={this.handleManualPairingGuide}
                underline="hover"
                sx={{ color: "#1976d2", cursor: "pointer" }}
              >
                <strong>Pairing Guide</strong>
              </Link>{" "}
              for additional help. Once complete, come{" "}
              <strong>back to this page</strong> to verify account pairing.
            </p>
          )}
        </div>
      );
    } else if (this.state.step === 4 && this.state.accountType === "AWS") {
      content = (
        <div>
          <p>
            <strong style={{ fontSize: "1.2em" }}>
              Step 3 : Enable AWS Resource Explorer
            </strong>
          </p>
          <p>
            Enable AWS Resource Explorer to discover your resources across AWS
            Regions and accounts. Follow the{" "}
            <Link
              component="button"
              onClick={this.handleResourceExplorerGuide}
              underline="hover"
              sx={{ color: "#1976d2", cursor: "pointer" }}
            >
              <strong>Resource Explorer Guide</strong>
            </Link>{" "}
            for additional help.
          </p>
        </div>
      );
    } else if (this.state.step === 5) {
      content = (
        <div>
          <p>
            <strong style={{ fontSize: "1.2em" }}>
              Step 4 : Verify Account Pairing
            </strong>
          </p>
          <p style={{ fontSize: "1em" }}>Verify the newly created Pairing</p>
        </div>
      );
    }

    if (!content) {
      return null;
    }

    return ReactDOM.createPortal(content, host);
  };

  render() {
    console.log("Rerender Props: ============", this.props);
    console.log("accountStatusLoading: ", this.props.accountStatusLoading);
    console.log("accountStatusResult: ", this.props.accountStatusResult);
    console.log("accountStatusError: ", this.props.accountStatusError);
    console.log("Rerender Props: ============");

    let showTextArea = false;

    return (
      <React.Fragment>
        {this.renderWizardChrome()}
        <SnackbarProvider />
        <style>
          {`
            /* Ensure react-select dropdown menu is scrollable with mouse wheel */
            .resource-group-select__menu {
              overflow-y: auto !important;
              overflow-x: hidden !important;
              max-height: 200px !important;
            }
            .resource-group-select__menu-list {
              overflow-y: auto !important;
              overflow-x: hidden !important;
              max-height: 200px !important;
              padding: 0 !important;
              /* Enable smooth scrolling and ensure mouse wheel works */
              -webkit-overflow-scrolling: touch;
              scroll-behavior: smooth;
            }
            /* Ensure the menu container can receive scroll events */
            body > div[id*="react-select"] .resource-group-select__menu-list {
              overflow-y: auto !important;
              overflow-x: hidden !important;
              max-height: 200px !important;
            }
            /* Subtle animation for Click to Launch button */
            @keyframes subtlePulse {
              0%, 100% {
                transform: scale(1);
                box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);
              }
              50% {
                transform: scale(1.02);
                box-shadow: 0 4px 8px rgba(25, 118, 210, 0.5);
              }
            }
            /* Subtle animation for Enable Resource Explorer button */
            @keyframes subtlePulseOrange {
              0%, 100% {
                transform: scale(1);
                box-shadow: 0 2px 4px rgba(249, 129, 37, 0.3);
              }
              50% {
                transform: scale(1.02);
                box-shadow: 0 4px 8px rgba(249, 129, 37, 0.5);
              }
            }
            .click-to-launch-animated {
              animation: subtlePulse 2.5s ease-in-out infinite;
            }
            .enable-resource-explorer-animated {
              animation: subtlePulseOrange 2.5s ease-in-out infinite;
            }
            /* Compact Azure Step 2 pairing form so dialog stays within viewport */
            .azure-pairing-step .azure-pairing-actions {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
            }
            .azure-pairing-step .azure-pairing-actions .btn {
              min-width: 120px;
              width: 120px;
            }
            .azure-pairing-fields label {
              display: block;
              margin-bottom: 4px;
              font-size: 0.875rem;
              font-weight: 600;
              color: #333;
            }
            .azure-pairing-fields .form-group {
              margin-bottom: 0;
            }
            .azure-pairing-fields .azure-pairing-field-row {
              margin-bottom: 10px;
            }
            .azure-pairing-fields .azure-pairing-field-row:last-child {
              margin-bottom: 0;
            }
            .azure-pairing-fields .azure-pairing-input-with-copy {
              display: flex;
              align-items: center;
              gap: 4px;
            }
            .azure-pairing-fields .azure-pairing-input-with-copy .form-control {
              flex: 1;
              min-width: 0;
            }
            .azure-pairing-fields .azure-pairing-copy-btn {
              padding: 6px;
              flex-shrink: 0;
            }
            /* Step chrome lives above the tabs; drop reserved wizard min-height */
            #basic-pills-wizard .twitter-bs-wizard-tab-content {
              min-height: 0;
              padding-top: 8px;
            }
            .cloud-account-type-options {
              display: flex;
              gap:130px;
              margin-top: 16px;
              margin-bottom: 8px;
              width: 100%;
              justify-content: center;
              align-items: stretch;
            }
            .cloud-account-type-option {
              flex: 0 0 auto;
              margin: 0;
              cursor: pointer;
            }
            .cloud-account-type-card {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: fit-content;
              height: fit-content;
              min-height: 0;
              padding: 0;
              line-height: 0;
              overflow: hidden;
              border: 2px solid #e0e0e0;
              border-radius: 8px;
              background-color: #fafafa;
              transition: border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease, filter 150ms ease, opacity 150ms ease;
            }
            .cloud-account-type-card img {
              display: block;
              height: 56px;
              width: auto;
              max-width: none;
              object-fit: contain;
              transition: filter 150ms ease, opacity 150ms ease;
            }
            .cloud-account-type-option input:checked + .cloud-account-type-card {
              border-color: #f98125;
              background-color: #fff;
              box-shadow: 0 2px 10px rgba(249, 129, 37, 0.18);
            }
            .cloud-account-type-option input:not(:checked) + .cloud-account-type-card {
              filter: grayscale(1);
              opacity: 0.55;
            }
            .cloud-account-type-option:hover .cloud-account-type-card {
              border-color: #cfcfcf;
              opacity: 0.85;
              filter: grayscale(0.35);
            }
            .cloud-account-type-option input:checked + .cloud-account-type-card,
            .cloud-account-type-option:hover input:checked + .cloud-account-type-card {
              filter: none;
              opacity: 1;
            }
          `}
        </style>
        <div>
          <Container fluid={true}>
            <Row>
              <Col sm="12" md="12">
                <Card className="mb-0 border-0 shadow-none">
                  <CardBody className="p-0">
                    <div
                      id="basic-pills-wizard"
                      className="twitter-bs-wizard"
                    >
                      <TabContent
                        activeTab={this.state.activeTab}
                        className="twitter-bs-wizard-tab-content"
                      >
                        <TabPane tabId={1}>
                          {/* Step 1: Select Cloud & Enter Account Details (merged) */}
                          {this.state.step === 1 && (
                            <div className="row">
                              <div className="col-sm-12">
                                {(this.state.accountType === "AWS" ||
                                  this.state.accountType === "AZURE") && (
                                  <Card
                                    className="mb-0"
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "8px",
                                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
                                    }}
                                  >
                                    <CardBody>
                                  <AvForm className="form-horizontal">
                                    {this.state.currentStepError && (
                                      <small className="alert-danger header">
                                        {" "}
                                        Please fill all required fields
                                      </small>
                                    )}
                                    {this.props.reg_acct_error &&
                                    typeof this.props.reg_acct_error ===
                                      "string" ? (
                                      <small className="alert-danger header">
                                        {this.props.reg_acct_error}
                                      </small>
                                    ) : null}
                                    <div className="d-flex">
                                      <FormGroup className="mb-3 w-100">
                                        <input
                                          type="text"
                                          name="orgName"
                                          className="form-control"
                                          value={
                                            this.state.orgName ||
                                            (this.props.organizations &&
                                            this.props.organizations.length !== 0
                                              ? this.props.organizations[0].orgname
                                              : "")
                                          }
                                          disabled
                                          readOnly
                                          aria-label="Organization name"
                                          style={{
                                            backgroundColor: "#e9ecef",
                                            color: "#6c757d",
                                            cursor: "not-allowed",
                                          }}
                                        />
                                      </FormGroup>
                                    </div>
                                    <Row>
                                      <Col lg="12">
                                        <FormGroup className="mb-3">
                                          <AvField
                                            name="accountNumber"
                                            value={this.state.accountNumber}
                                            placeholder={
                                              this.state.accountType === "AZURE"
                                                ? "Subscription ID*"
                                                : "Account Number*"
                                            }
                                            type="text"
                                            className={`form-control ${
                                              this.state.accountType === "AZURE"
                                                ? ((this.state.accountNumber.trim() !==
                                                    "" ||
                                                    this.state.currentStepError) &&
                                                  !this.isValidAzureGuid(
                                                    this.state.accountNumber
                                                  )
                                                    ? "is-invalid-border"
                                                    : null)
                                                : this.state.currentStepError &&
                                                  this.state.accountNumber === ""
                                                ? "is-invalid-border"
                                                : null
                                            }`}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleAccountNumberBlur}
                                            errorMessage={
                                              this.state.accountType === "AZURE"
                                                ? "Enter Subscription ID"
                                                : "Enter account number"
                                            }
                                            validate={
                                              this.state.accountType === "AWS"
                                                ? {
                                                    required: {
                                                      value: true,
                                                      errorMessage:
                                                        "Account number is required",
                                                    },
                                                    pattern: {
                                                      value: "^[0-9]+$",
                                                      errorMessage:
                                                        "Account number must include only numbers",
                                                    },
                                                    minLength: {
                                                      value: 12,
                                                      errorMessage:
                                                        "Account number must be minimum 12 digits",
                                                    },
                                                    maxLength: {
                                                      value: 12,
                                                      errorMessage:
                                                        "Account number cannot be more than 12 digits",
                                                    },
                                                  }
                                                : {
                                                    required: {
                                                      value: true,
                                                      errorMessage:
                                                        "Subscription ID is required",
                                                    },
                                                    pattern: {
                                                      value:
                                                        "^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}|[0-9a-fA-F]{32})$",
                                                      errorMessage:
                                                        "Enter a valid Subscription ID (32 hex characters, hyphens optional)",
                                                    },
                                                  }
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg="12">
                                        <FormGroup className="mb-3">
                                          <AvField
                                            name="accountName"
                                            value={this.state.accountName}
                                            placeholder="Account Name*"
                                            type="text"
                                            errorMessage="Enter account name"
                                            className={`form-control ${
                                              this.state.currentStepError &&
                                              this.state.accountName === ""
                                                ? "is-invalid-border"
                                                : null
                                            }`}
                                            onChange={this.handleInputChange}
                                            validate={{
                                              required: {
                                                value: true,
                                                errorMessage:
                                                  "Account name is required",
                                              },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg="9">
                                        <FormGroup className="mb-3">
                                          <label htmlFor="resourcegroupfield">
                                            Resource Group (Optional)
                                          </label>
                                          <Creatable
                                            name="rgs"
                                            id="resourcegroupfield"
                                            classNamePrefix="resource-group-select"
                                            isClearable
                                            value={
                                              Array.isArray(this.state.selectedOption) &&
                                              this.state.selectedOption.length === 0
                                                ? { value: "Default", label: "Default" }
                                                : this.state.selectedOption || {
                                                    value: "Default",
                                                    label: "Default",
                                                  }
                                            }
                                            onChange={this.handleSelectChange}
                                            formatCreateLabel={(inputValue) =>
                                              `Create ResourceGroup "${inputValue}"`
                                            }
                                            placeholder={
                                              "Select/create a resource group"
                                            }
                                            options={
                                              this.props.organizations &&
                                              this.props.organizations.length !==
                                                0
                                                ? this.props.organizations[0].resourceGroups.map(
                                                    (rg) => {
                                                      return {
                                                        value: rg.resourcename,
                                                        label: rg.resourcename,
                                                      };
                                                    }
                                                  )
                                                : null
                                            }
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                            styles={{
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                              menu: (base) => ({
                                                ...base,
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                              }),
                                              menuList: (base) => ({
                                                ...base,
                                                padding: 0,
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                              }),
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                    {this.props.error ? (
                                      <Alert color="danger">
                                        Error registering account, please check your
                                        details
                                        {this.props.reg_acct_error}
                                      </Alert>
                                    ) : null}
                                  </AvForm>
                                    </CardBody>
                                  </Card>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Step 3: Account Pairing */}
                          {this.state.step === 3 && (
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="d-flex flex-column">
                                  {this.state.accountType === "AZURE" ? (
                                    <>
                                      {this.state.azureTemplateError ? (
                                        <Alert color="danger" className="mt-2">
                                          {this.state.azureTemplateError}
                                        </Alert>
                                      ) : null}
                                      <div className="azure-pairing-step">
                                          <div className="azure-pairing-actions">
                                            <button
                                              className="btn w-lg btn-primary"
                                              type="button"
                                              onClick={this.handleAzureTemplateView}
                                              disabled={
                                                this.state.azureTemplateLoading ||
                                                this.props.isRegisteringOrgAccount ||
                                                this.state.azureFetchDetailsLoading
                                              }
                                            >
                                              {this.state.azureTemplateLoading ? (
                                                <span>
                                                  <i className="fa fa-spinner fa-spin" />{" "}
                                                  Loading...
                                                </span>
                                              ) : (
                                                "View"
                                              )}
                                            </button>
                                            <button
                                              className="btn w-lg btn-primary"
                                              type="button"
                                              onClick={this.fetchAzureLighthouseDetails}
                                              disabled={
                                                !this.state.azureTemplateReady ||
                                                this.state.azureFetchDetailsLoading ||
                                                this.props.isRegisteringOrgAccount ||
                                                this.state.azureTemplateLoading
                                              }
                                            >
                                              {this.state.azureFetchDetailsLoading ? (
                                                <span>
                                                  <i className="fa fa-spinner fa-spin" />{" "}
                                                  Loading...
                                                </span>
                                              ) : (
                                                "Fetch"
                                              )}
                                            </button>
                                          </div>
                                          <Card
                                            className="mb-0"
                                            style={{
                                              border: "1px solid #e0e0e0",
                                              borderRadius: "8px",
                                              boxShadow:
                                                "0 1px 3px rgba(0, 0, 0, 0.06)",
                                            }}
                                          >
                                            <CardBody
                                              className="azure-pairing-fields"
                                              style={{ padding: "14px 16px" }}
                                            >
                                          <div className="azure-pairing-field-row">
                                            <FormGroup className="mb-0">
                                              <label>Customer Tenant ID*</label>
                                              <div className="azure-pairing-input-with-copy">
                                                <input
                                                  type="text"
                                                  name="customerTenantId"
                                                  value={
                                                    this.state.customerTenantId
                                                  }
                                                  placeholder="Customer Tenant ID*"
                                                  className={`form-control ${
                                                    ((this.state.customerTenantId.trim() !==
                                                      "" ||
                                                      this.state
                                                        .currentStepError) &&
                                                      !this.isValidAzureGuid(
                                                        this.state.customerTenantId
                                                      ))
                                                      ? "is-invalid-border"
                                                      : null
                                                  }`}
                                                  onChange={
                                                    this.handleInputChange
                                                  }
                                                  onBlur={() =>
                                                    this.handleAzureGuidFieldBlur(
                                                      "customerTenantId"
                                                    )
                                                  }
                                                />
                                                <Tooltip
                                                  title={
                                                    this.state.copiedField ===
                                                    "customerTenantId"
                                                      ? "Copied"
                                                      : "Click to copy"
                                                  }
                                                >
                                                  <span>
                                                    <IconButton
                                                      className="azure-pairing-copy-btn"
                                                      disabled={
                                                        !this.state.customerTenantId
                                                      }
                                                      onClick={() =>
                                                        this.handleCopyAzureField(
                                                          "customerTenantId",
                                                          this.state.customerTenantId
                                                        )
                                                      }
                                                    >
                                                      <ContentCopyIcon
                                                        fontSize="small"
                                                        color={
                                                          this.state.copiedField ===
                                                          "customerTenantId"
                                                            ? "primary"
                                                            : "inherit"
                                                        }
                                                      />
                                                    </IconButton>
                                                  </span>
                                                </Tooltip>
                                              </div>
                                              {((this.state.customerTenantId.trim() !==
                                                "" ||
                                                this.state.currentStepError) &&
                                                !this.isValidAzureGuid(
                                                  this.state.customerTenantId
                                                )) && (
                                                <small className="text-danger">
                                                  Enter a valid Customer Tenant
                                                  ID (32 hex characters, hyphens
                                                  optional)
                                                </small>
                                              )}
                                            </FormGroup>
                                          </div>
                                          <div className="azure-pairing-field-row">
                                            <FormGroup className="mb-0">
                                              <label>Subscription ID*</label>
                                              <div className="azure-pairing-input-with-copy">
                                                <input
                                                  type="text"
                                                  disabled={true}
                                                  value={this.state.accountNumber}
                                                  className="form-control"
                                                />
                                                <Tooltip
                                                  title={
                                                    this.state.copiedField ===
                                                    "subscriptionId"
                                                      ? "Copied"
                                                      : "Click to copy"
                                                  }
                                                >
                                                  <span>
                                                    <IconButton
                                                      className="azure-pairing-copy-btn"
                                                      disabled={!this.state.accountNumber}
                                                      onClick={() =>
                                                        this.handleCopyAzureField(
                                                          "subscriptionId",
                                                          this.state.accountNumber
                                                        )
                                                      }
                                                    >
                                                      <ContentCopyIcon
                                                        fontSize="small"
                                                        color={
                                                          this.state.copiedField ===
                                                          "subscriptionId"
                                                            ? "primary"
                                                            : "inherit"
                                                        }
                                                      />
                                                    </IconButton>
                                                  </span>
                                                </Tooltip>
                                              </div>
                                            </FormGroup>
                                          </div>
                                          <div className="azure-pairing-field-row">
                                            <FormGroup className="mb-0">
                                              <label>
                                                Registration Definition ID*
                                              </label>
                                              <div className="azure-pairing-input-with-copy">
                                                <input
                                                  type="text"
                                                  name="registrationDefinitionId"
                                                  value={
                                                    this.state
                                                      .registrationDefinitionId
                                                  }
                                                  placeholder="Last 32 characters of the generated registrationDefinitionId GUID*"
                                                  className={`form-control ${
                                                    ((this.state.registrationDefinitionId.trim() !==
                                                      "" ||
                                                      this.state
                                                        .currentStepError) &&
                                                      !this.isValidAzureGuid(
                                                        this.state
                                                          .registrationDefinitionId
                                                      ))
                                                      ? "is-invalid-border"
                                                      : null
                                                  }`}
                                                  onChange={
                                                    this.handleInputChange
                                                  }
                                                  onBlur={() =>
                                                    this.handleAzureGuidFieldBlur(
                                                      "registrationDefinitionId"
                                                    )
                                                  }
                                                />
                                                <Tooltip
                                                  title={
                                                    this.state.copiedField ===
                                                    "registrationDefinitionId"
                                                      ? "Copied"
                                                      : "Click to copy"
                                                  }
                                                >
                                                  <span>
                                                    <IconButton
                                                      className="azure-pairing-copy-btn"
                                                      disabled={
                                                        !this.state
                                                          .registrationDefinitionId
                                                      }
                                                      onClick={() =>
                                                        this.handleCopyAzureField(
                                                          "registrationDefinitionId",
                                                          this.state
                                                            .registrationDefinitionId
                                                        )
                                                      }
                                                    >
                                                      <ContentCopyIcon
                                                        fontSize="small"
                                                        color={
                                                          this.state.copiedField ===
                                                          "registrationDefinitionId"
                                                            ? "primary"
                                                            : "inherit"
                                                        }
                                                      />
                                                    </IconButton>
                                                  </span>
                                                </Tooltip>
                                              </div>
                                              {((this.state.registrationDefinitionId.trim() !==
                                                "" ||
                                                this.state.currentStepError) &&
                                                !this.isValidAzureGuid(
                                                  this.state
                                                    .registrationDefinitionId
                                                )) && (
                                                <small className="text-danger">
                                                  Enter a valid Registration
                                                  Definition ID (32 hex
                                                  characters, hyphens optional)
                                                </small>
                                              )}
                                            </FormGroup>
                                          </div>
                                          <div className="azure-pairing-field-row">
                                            <FormGroup className="mb-0">
                                              <label>
                                                Registration Assignment ID*
                                              </label>
                                              <div className="azure-pairing-input-with-copy">
                                                <input
                                                  type="text"
                                                  name="registrationAssignmentId"
                                                  value={
                                                    this.state
                                                      .registrationAssignmentId
                                                  }
                                                  placeholder="Last 32 characters of the generated registrationAssignmentId GUID*"
                                                  className={`form-control ${
                                                    ((this.state.registrationAssignmentId.trim() !==
                                                      "" ||
                                                      this.state
                                                        .currentStepError) &&
                                                      !this.isValidAzureGuid(
                                                        this.state
                                                          .registrationAssignmentId
                                                      ))
                                                      ? "is-invalid-border"
                                                      : null
                                                  }`}
                                                  onChange={
                                                    this.handleInputChange
                                                  }
                                                  onBlur={() =>
                                                    this.handleAzureGuidFieldBlur(
                                                      "registrationAssignmentId"
                                                    )
                                                  }
                                                />
                                                <Tooltip
                                                  title={
                                                    this.state.copiedField ===
                                                    "registrationAssignmentId"
                                                      ? "Copied"
                                                      : "Click to copy"
                                                  }
                                                >
                                                  <span>
                                                    <IconButton
                                                      className="azure-pairing-copy-btn"
                                                      disabled={
                                                        !this.state
                                                          .registrationAssignmentId
                                                      }
                                                      onClick={() =>
                                                        this.handleCopyAzureField(
                                                          "registrationAssignmentId",
                                                          this.state
                                                            .registrationAssignmentId
                                                        )
                                                      }
                                                    >
                                                      <ContentCopyIcon
                                                        fontSize="small"
                                                        color={
                                                          this.state.copiedField ===
                                                          "registrationAssignmentId"
                                                            ? "primary"
                                                            : "inherit"
                                                        }
                                                      />
                                                    </IconButton>
                                                  </span>
                                                </Tooltip>
                                              </div>
                                              {((this.state.registrationAssignmentId.trim() !==
                                                "" ||
                                                this.state.currentStepError) &&
                                                !this.isValidAzureGuid(
                                                  this.state
                                                    .registrationAssignmentId
                                                )) && (
                                                <small className="text-danger">
                                                  Enter a valid Registration
                                                  Assignment ID (32 hex
                                                  characters, hyphens optional)
                                                </small>
                                              )}
                                            </FormGroup>
                                          </div>
                                            </CardBody>
                                          </Card>
                                        </div>
                                    </>
                                  ) : (
                                  <>
                                  <hr />
                                  <div
                                    style={{
                                      display: "flex",
                                    }}
                                  >
                                    <button
                                      id="showLinkBtnId"
                                      className="btn btn-link"
                                      onClick={() => {
                                        showTextArea = !showTextArea;
                                        if (showTextArea) {
                                          document.getElementById(
                                            "showLinkBtnId"
                                          ).textContent = "Hide Link";
                                          document.getElementById(
                                            "consoleBodyId"
                                          ).style.display = "block";
                                        } else {
                                          document.getElementById(
                                            "showLinkBtnId"
                                          ).textContent = "Show Link";
                                          document.getElementById(
                                            "consoleBodyId"
                                          ).style.display = "none";
                                        }
                                      }}
                                    >
                                      Show Link
                                    </button>
                                    <button
                                      id="clickToCopyBtnId"
                                      className="btn btn-link"
                                      onClick={this.handleClicktoCopy}
                                    >
                                      Copy Link
                                    </button>
                                    <button
                                      className="btn click-to-launch-animated"
                                      onClick={() =>
                                        window.open(
                                          this.linkTextAreaRef.current
                                            .textContent
                                        )
                                      }
                                      style={{
                                        backgroundColor: "#1976d2",
                                        color: "#FFFFFF",
                                        fontWeight: "bold",
                                        padding: "10px 24px",
                                        fontSize: "1.05em",
                                        border: "none",
                                        borderRadius: "4px",
                                        textDecoration: "none",
                                      }}
                                    >
                                      Click to Launch
                                    </button>
                                    <Tooltip
                                      title="Please make sure you are logged in the AWS account you are onboarding, prior to completing this step.
                                                Open a new tab in your browser. Copy the link above and paste it in the URL bar of this new tab.
                                                Complete setting up a role through AWS IAM role creation console, make sure that the role's name is set as:
                                                CloudCatcherTrustRole"
                                      PopperProps={{
                                        disablePortal: true,
                                      }}
                                      onClose={() =>
                                        this.setState({
                                          showCopyLinkHelp: false,
                                        })
                                      }
                                      open={this.state.showCopyLinkHelp}
                                      placement="top"
                                      disableHoverListener
                                    >
                                      <button
                                        className="btn btn-sm btn-link text-dark"
                                        onClick={() =>
                                          this.setState({
                                            showCopyLinkHelp:
                                              !this.state.showCopyLinkHelp,
                                          })
                                        }
                                      >
                                        <i className="mdi mdi-help-circle mr-1"></i>
                                      </button>
                                    </Tooltip>
                                  </div>

                                  <div
                                    className="mb-3"
                                    id="consoleBodyId"
                                    style={{
                                      display: "none",
                                    }}
                                  >
                                    <textarea
                                      readOnly
                                      ref={this.linkTextAreaRef}
                                      className="form-control"
                                      rows="6"
                                      name="urlLink"
                                      value={`https://console.aws.amazon.com/iam/home#/roles$new?step=review&roleType=crossAccount&accountID=${this.props.aws}&policies=arn%3Aaws%3Aiam%3A%3Aaws%3Apolicy%2FReadOnlyAccess,arn%3Aaws%3Aiam%3A%3Aaws%3Apolicy%2FWellArchitectedConsoleFullAccess&roleName=${this.state.roleName}&externalId=${this.state.externalId}&trustedEntityType=AWS_ACCOUNT&isThirdParty=true&awsAccount=${this.props.aws}`}
                                      onChange={this.handleInputChange}
                                    />
                                  </div>
                                  </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Step 4: Enable AWS Resource Explorer (AWS only) */}
                          {this.state.step === 4 && this.state.accountType === "AWS" && (
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="d-flex flex-column">
                                  <hr />
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "20px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <button
                                      className="btn enable-resource-explorer-animated"
                                      disabled={this.props.isReleaseDetailsGetting}
                                      onClick={() => window.open(
                                        "https://resource-explorer.console.aws.amazon.com/resource-explorer/home?region=us-east-1#/home",
                                        "_blank"
                                      )}
                                      style={{
                                        backgroundColor: "#F98125",
                                        border: "solid 2px #000000",
                                        padding: "12px 24px",
                                        color: "#FFFFFF",
                                        fontWeight: "bold",
                                        fontSize: "1.05em",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      Enable AWS Resource Explorer
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Step 5: Verify Account Pairing (AWS only — Azure Step 3 is inline on Page 2) */}
                          {this.state.step === 5 && this.state.accountType === "AWS" && (
                            <div className="row">
                              <div className="col-sm-12">
                                <div>
                                  <div>
                                    <Row>
                                      <Col lg="10">
                                        <label>External Id</label>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg="10">
                                        <FormGroup className="mb-3">
                                          <input
                                            type="text"
                                            disabled={true}
                                            value={this.state.externalId}
                                            className={`form-control`}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col lg="2">
                                        <Tooltip
                                          title={
                                            this.state.copy
                                              ? "Copied"
                                              : "Click to copy"
                                          }
                                        >
                                          <IconButton
                                            onClick={this.handleClickExternalId}
                                          >
                                            <ContentCopyIcon
                                              color={
                                                this.state.copy ? "primary" : ""
                                              }
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg="10">
                                        <label>Role Name*</label>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg="10">
                                        <FormGroup className="mb-3">
                                          <input
                                            type="text"
                                            name="roleName"
                                            value={this.state.roleName}
                                            placeholder="Role Name*"
                                            className={`form-control ${
                                              this.state.currentStepError &&
                                              this.state.roleName === ""
                                                ? "is-invalid-border"
                                                : null
                                            }`}
                                            onChange={this.handleInputChange}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </div>
                                  <div>
                                    <button
                                      className="btn w-lg btn-primary"
                                      disabled={
                                        this.isAccountInvalid() ||
                                        this.props.accountStatusLoading ||
                                        this.isAccountVerified()
                                      }
                                      onClick={this.verifyPairedAccountStatus}
                                    >
                                      {this.props.accountStatusLoading ? (
                                        <>Verifying the pairing configuration...</>
                                      ) : this.state.verifyAccountSuccess ? (
                                        <>Pairing Verified</>
                                      ) : (
                                        <>Verify Pairing</>
                                      )}
                                    </button>
                                    <div>
                                      {this.state.verifyAccountSuccess && (
                                        <small className="alert-success header">
                                          {" "}
                                          {this.props.accountStatusResult || "Account Paired Successfully!!!"}
                                        </small>
                                      )}
                                      {this.state.verifyAccountError && (
                                        <small className="alert-danger header">
                                          {this.props.accountStatusError === "Pairing Cannot be Verified!" 
                                            ? "Pairing could not be verified, please verify the Role Name or rerun the pairing steps"
                                            : this.props.accountStatusError}
                                        </small>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </TabPane>
                      </TabContent>
                    </div>

                    <Snackbar
                      open={this.state.registerAccountError}
                      autoHideDuration={5000}
                    >
                      <Alert severity="error">
                        Error while creating the account.{" "}
                        {this.props.reg_acct_error}
                      </Alert>
                    </Snackbar>

                    {/* Show bottom buttons for all steps, but Submit only shows on step 5 after verification */}
                    {(this.state.step === 1 || this.state.step === 2 || this.state.step === 3 || this.state.step === 4 || this.state.step === 5) && (
                      <div
                        style={{
                          marginTop:
                            this.state.step === 3 &&
                            this.state.accountType === "AZURE"
                              ? "16px"
                              : "30px",
                          width: "100%",
                          display: "flex",
                          justifyContent:
                            this.state.step > 1 ? "space-between" : "flex-end",
                          alignItems: "center",
                        }}
                      >
                          {/* Show Back button for steps 2–5 — left aligned; Azure Step 2 also shows View */}
                          <div
                            style={{
                              display: "flex",
                              gap: "12px",
                              alignItems: "center",
                            }}
                          >
                          {this.state.step > 1 && (
                            <button
                              className="btn w-lg btn-secondary"
                              onClick={this.handleBack}
                              disabled={
                                this.props.isRegisteringOrgAccount ||
                                this.state.azureTemplateLoading ||
                                this.state.azureVerifyLoading ||
                                this.state.azureFetchDetailsLoading
                              }
                            >
                              Back
                            </button>
                          )}
                          </div>
                          {this.state.accountType === "AZURE" &&
                            this.state.step === 3 && (
                              <div
                                style={{
                                  flex: 1,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "0 12px",
                                  minHeight: 24,
                                }}
                              >
                                {this.state.azureStatusMessage ? (
                                  <span
                                    style={{
                                      color:
                                        this.state.azureStatusSeverity ===
                                        "success"
                                          ? "#2e7d32"
                                          : "#d32f2f",
                                      fontSize: "0.875rem",
                                      fontWeight: 500,
                                      textAlign: "center",
                                      lineHeight: 1.4,
                                    }}
                                  >
                                    {this.state.azureStatusSeverity ===
                                      "success" && (
                                      <i
                                        className="fa fa-check-circle"
                                        style={{ marginRight: 6 }}
                                        aria-hidden="true"
                                      />
                                    )}
                                    {this.state.azureStatusSeverity ===
                                      "error" && (
                                      <i
                                        className="fa fa-times-circle"
                                        style={{ marginRight: 6 }}
                                        aria-hidden="true"
                                      />
                                    )}
                                    {this.state.azureStatusMessage}
                                  </span>
                                ) : null}
                              </div>
                            )}
                          {/* Show Submit: Azure Step 2 always visible (disabled until valid); AWS Step 5 after verification */}
                          <div>
                          {this.state.accountType === "AZURE" &&
                          this.state.step === 3 ? (
                            <button
                              className="btn w-lg btn-primary"
                              disabled={
                                this.isAzureVerifyFormInvalid() ||
                                this.state.azureVerifyLoading ||
                                this.props.isRegisteringOrgAccount ||
                                this.state.azureFetchDetailsLoading
                              }
                              onClick={this.handleAzureSubmit}
                            >
                              {this.state.azureVerifyLoading ? (
                                <span>
                                  <i className="fa fa-spinner fa-spin" />{" "}
                                  Submitting...
                                </span>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          ) : this.state.step === 5 ? (
                            // Step 5 (AWS): Submit only after pairing verification
                            <button
                              className="btn w-lg btn-primary"
                              disabled={
                                this.state.verifyAccountSuccess !== true || 
                                this.isCurrentStepInvalid() || 
                                this.props.isRegisteringOrgAccount
                              }
                              onClick={this.handleNext}
                            >
                              {this.props.isRegisteringOrgAccount ? (
                                <span>
                                  <i className="fa fa-spinner fa-spin" />{" "}
                                  Submitting...
                                </span>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          ) : (
                            // Next on Steps 1–4 (Azure pairing uses Fetch, not Next)
                            <button
                              className="btn w-lg btn-primary"
                              disabled={
                                this.isCurrentStepInvalid() ||
                                this.props.isRegisteringOrgAccount ||
                                this.state.azureFetchDetailsLoading
                              }
                              onClick={this.handleNext}
                            >
                              {this.state.azureFetchDetailsLoading ? (
                                <span>
                                  <i className="fa fa-spinner fa-spin" />{" "}
                                  Loading...
                                </span>
                              ) : (
                                "Next"
                              )}
                            </button>
                          )}
                          </div>
                      </div>
                    )}

                    <>
                      <Modal isOpen={this.props.registerOrgAccountMessage ? true : false}>
                        <ModalBody>
                          <p>
                            You have successfully added your AWS account. Please proceed to configuring the FinOps, Cost Optimization, and Cloud Event features for your account.
                          </p>
                        </ModalBody>
                        <ModalFooter>
                          <Button onClick={this.closeAcctSuccesmsg}>
                            close
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </>                  
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    account,
    accounts,
    organizations,
    reg_acct_error,
    loading,
    error,
    message,
    registerOrgAccountMessage,
    isRegisteringOrgAccount
  } = state.orgAccount;
  const { aws } = state.awsAcc;
  const {
    isReleaseDetailsGetting,
    getReleaseDetailsMessage,
    getReleaseDetailsError,
    releaseDetails,
  } = state.releaseNotes;

  const {
    accountStatusLoading,
    accountStatusResult,
    accountStatusError,
  } = state.scanService;

  return {
    account,
    accounts,
    organizations,
    reg_acct_error,
    loading,
    message,
    registerOrgAccountMessage,
    isRegisteringOrgAccount,

    aws,
    error,
    isReleaseDetailsGetting,
    getReleaseDetailsMessage,
    getReleaseDetailsError,
    releaseDetails,

    accountStatusLoading,
    accountStatusResult,
    accountStatusError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListOfOrgsAndAccts: () => {
      dispatch(getListOfOrgsAndAccts());
    },
    registerOrgAccount: (data) => {
      dispatch(registerOrgAccount(data));
    },
    resetOrgAccountStatus: () => {
      dispatch(registerOrgAccountSuccessful(null));
    },
    clearAllOrgAccountMessages: () => {
      dispatch(clearAllOrgAccountMessages());
    },
    getAwsAcc: () => {
      dispatch(getAwsAcc());
    },
    getReleaseDetails: (fileName) => {
      dispatch(getReleaseDetailsRequest(fileName));
    },
    clearAllReleaseMessages: () => {
      dispatch(clearAllReleaseMessages());
    },
    verifyAccountStatus: (accountNumber, roleName, externalId) => {
      dispatch(
        verifyAccountStatusRequest({ accountNumber, roleName, externalId })
      );
    },
    clearAllScanServiceMessages: () => {
      dispatch(clearAllScanServiceMessages());
    },
  };
};

export default connect(mapStatetoProps, mapDispatchToProps)(OrgAccount);
